module.exports = __webpack_public_path__ + "static/media/icon-brujula.328c0e7d.webp";